import { Checkbox } from "primereact/checkbox"
import { InputText } from "primereact/inputtext"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"

const DevengoModelo390 = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
}) => {
  const { t } = useTranslation()
  const values = watch()
  const isSustitutiva =
    values?.declaracionSustitutiva || values?.sustitutivaPorRectificacion

  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col tw-text-left'>
      <div className='tw-w-full tw-gap-3 tw-min-h-14 tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-3 tw-border-t tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-font-normal'>
          {t("taxSummary.declaracion.devengoModelo.ejercicio")}
        </span>
        <InputText
          value={`${values?.ejercicio}`}
          className='tw-text-sm'
          disabled
        />
      </div>

      <div className='tw-flex tw-justify-between tw-items-center tw-py-3 tw-w-full tw-gap-3 tw-min-h-14 tw-p-0 tw-border-t tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm'>{t("Declaración sustitutiva")}</span>
        <Checkbox
          id='declaracionSustitutiva'
          checked={values?.declaracionSustitutiva}
          onChange={() =>
            setValue("declaracionSustitutiva", !values?.declaracionSustitutiva)
          }
        />
      </div>

      <div className='tw-flex tw-justify-between tw-items-center tw-py-3 tw-w-full tw-gap-3 tw-min-h-14 tw-p-0 tw-border-t tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm'>
          {t(
            "Declaración sustitutiva por rectificación de cuotas deducidas en caso de concurso de acreedores (art. 80.Tres LIVA)"
          )}
        </span>
        <Checkbox
          id='sustitutivaPorRectificacion'
          checked={values?.sustitutivaPorRectificacion}
          onChange={() =>
            setValue(
              "sustitutivaPorRectificacion",
              !values?.sustitutivaPorRectificacion
            )
          }
        />
      </div>

      <div className='tw-w-full tw-gap-3 tw-min-h-14 tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-3 tw-border-t tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-font-normal'>
          {t("modelo390.identificacion.numJustAnterior")}
        </span>
        <InputText
          className='tw-text-sm'
          value={values?.numeroJustificanteAnterior}
          onChange={(e) =>
            setValue("numeroJustificanteAnterior", e.target.value)
          }
          disabled={!isSustitutiva}
        />
      </div>
      <span className='tw-text-xs tw-text-right tw-w-full tw-py-1 tw-px-6 tw-border-t tw-border-neutral-25'>
        {t("taxSummary.declaracion.infoMsg")}
      </span>
    </div>
  )
}
export default DevengoModelo390
